import * as yup from 'yup';

import { EXCLUSION_REASON_ENABLED } from '../../constants';
import { EAssessmentDecision, EExclusionReason } from '../../types';

const isExcluded = (decision: unknown): boolean =>
  Array.isArray(decision) && decision[0] === EAssessmentDecision.EXCLUDED;
const isOtherReason = (reason: unknown): boolean => Array.isArray(reason) && reason[0] === EExclusionReason.OTHER;

// BE mirrors these rules in assessments.service.ts validateDecisionFields - update both together.
export const assessmentFormSchema = yup
  .object({
    products: yup
      .array()
      .of(yup.string().required())
      .min(1, 'At least one product is required.')
      .test('unique-products', 'Each product can only be selected once.', (v) => !v || new Set(v).size === v.length)
      .required(),
    decision: yup.array().of(yup.string().required()).min(1, 'Decision is required.').required(),
    // Inner .required() omitted so the "no selection" option (value="") passes validation.
    reviewingStage: yup.array().of(yup.string().defined()).notRequired(),
    exclusionReason: yup
      .array()
      .of(yup.string().required())
      .when('decision', {
        is: (d: unknown) => EXCLUSION_REASON_ENABLED && isExcluded(d),
        then: (s) => s.min(1, 'Exclusion reason is required.').required(),
        otherwise: (s) => s.notRequired(),
      }),
    comment: yup
      .string()
      .max(5000)
      .when(['decision', 'exclusionReason'], {
        is: (d: unknown, r: unknown) => EXCLUSION_REASON_ENABLED && isExcluded(d) && isOtherReason(r),
        then: (s) => s.trim().min(1, 'Please describe the reason for exclusion.').required(),
        otherwise: (s) => s.notRequired(),
      }),
  })
  .required();

export type TAssessmentFormData = yup.InferType<typeof assessmentFormSchema>;
